var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330.596,
    height: 108,
    viewBox: "0 0 330.596 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20541",
    "data-name": "Rectangle 20541",
    width: 330.596,
    height: 108,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(-113.428 -211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(113.428 211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12876",
    "data-name": "Path 12876",
    d: "M503.375,103.582a14.155,14.155,0,0,1-4.15-10.615,14.064,14.064,0,0,1,4.19-10.654,15.088,15.088,0,0,1,10.894-3.99,14.825,14.825,0,0,1,10.734,4.389l-4.549,4.669a8.543,8.543,0,0,0-6.026-2.394,7.3,7.3,0,0,0-5.547,2.194,8.973,8.973,0,0,0,0,11.572,7.3,7.3,0,0,0,5.547,2.195,9.428,9.428,0,0,0,6.784-2.714l4.27,4.948a15.366,15.366,0,0,1-11.054,4.429c-4.669,0-8.34-1.357-11.093-4.03",
    transform: "translate(-373.118 -58.538)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12877",
    "data-name": "Path 12877",
    d: "M623.555,112.369h6.3v19.713h-6.3l-.4-2.315a8.3,8.3,0,0,1-6.3,2.714,8.553,8.553,0,0,1-6.664-2.873,11.8,11.8,0,0,1,0-14.764,8.552,8.552,0,0,1,6.664-2.873,8.264,8.264,0,0,1,6.3,2.674ZM618.727,126.5a3.794,3.794,0,0,0,2.873-1.2,4.307,4.307,0,0,0,1.078-3.072,4.476,4.476,0,0,0-1.078-3.113,3.91,3.91,0,0,0-2.873-1.157,3.757,3.757,0,0,0-2.833,1.157,4.321,4.321,0,0,0-1.117,3.113,4.161,4.161,0,0,0,1.117,3.072,3.649,3.649,0,0,0,2.833,1.2",
    transform: "translate(-454.112 -83.686)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12878",
    "data-name": "Path 12878",
    d: "M733.516,120.671v11.293h-7.263V121.07c0-2.035-1.077-3.272-2.873-3.272-1.955,0-3.312,1.516-3.312,3.791v10.375h-7.262V112.251h6.3l.4,2.315a7.75,7.75,0,0,1,6.225-2.753c4.788,0,7.781,3.272,7.781,8.859",
    transform: "translate(-532.747 -83.568)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12879",
    "data-name": "Path 12879",
    d: "M821.962,81.009h7.262v27.933h-6.3l-.4-2.315a8.3,8.3,0,0,1-6.3,2.714,8.553,8.553,0,0,1-6.664-2.873,11.8,11.8,0,0,1,0-14.764,8.552,8.552,0,0,1,6.664-2.873,8.157,8.157,0,0,1,5.746,2.155Zm-3.871,22.346a3.794,3.794,0,0,0,2.873-1.2,4.307,4.307,0,0,0,1.078-3.072,4.476,4.476,0,0,0-1.078-3.113,3.91,3.91,0,0,0-2.873-1.157,3.757,3.757,0,0,0-2.833,1.157,4.32,4.32,0,0,0-1.117,3.113,4.16,4.16,0,0,0,1.117,3.072,3.649,3.649,0,0,0,2.833,1.2",
    transform: "translate(-603.115 -60.546)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12880",
    "data-name": "Path 12880",
    d: "M910.273,81.955a3.8,3.8,0,0,1,4.11-3.791c2.434,0,4.15,1.556,4.15,3.791,0,2.195-1.716,3.751-4.15,3.751a3.794,3.794,0,0,1-4.11-3.751m.479,5.147h7.263v19.713h-7.263Z",
    transform: "translate(-680.332 -58.419)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12881",
    "data-name": "Path 12881",
    d: "M968.878,81.009h7.262v27.933h-6.3l-.4-2.315a8.3,8.3,0,0,1-6.3,2.714,8.553,8.553,0,0,1-6.664-2.873,11.8,11.8,0,0,1,0-14.764,8.552,8.552,0,0,1,6.664-2.873,8.158,8.158,0,0,1,5.746,2.155Zm-3.871,22.346a3.794,3.794,0,0,0,2.873-1.2,4.306,4.306,0,0,0,1.078-3.072,4.475,4.475,0,0,0-1.078-3.113,3.909,3.909,0,0,0-2.873-1.157,3.757,3.757,0,0,0-2.833,1.157,4.32,4.32,0,0,0-1.117,3.113,4.16,4.16,0,0,0,1.117,3.072,3.649,3.649,0,0,0,2.833,1.2",
    transform: "translate(-712.92 -60.546)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12882",
    "data-name": "Path 12882",
    d: "M1070.94,112.369h6.3v19.713h-6.3l-.4-2.315a8.3,8.3,0,0,1-6.3,2.714,8.553,8.553,0,0,1-6.664-2.873,11.8,11.8,0,0,1,0-14.764,8.552,8.552,0,0,1,6.664-2.873,8.265,8.265,0,0,1,6.3,2.674Zm-4.828,14.126a3.8,3.8,0,0,0,2.873-1.2,4.307,4.307,0,0,0,1.077-3.072,4.476,4.476,0,0,0-1.077-3.113,3.911,3.911,0,0,0-2.873-1.157,3.757,3.757,0,0,0-2.833,1.157,4.32,4.32,0,0,0-1.118,3.113,4.16,4.16,0,0,0,1.118,3.072,3.649,3.649,0,0,0,2.833,1.2",
    transform: "translate(-788.484 -83.686)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12883",
    "data-name": "Path 12883",
    d: "M1170.781,116.013a11.816,11.816,0,0,1-5.706,1.317c-4.829,0-7.263-2.674-7.263-7.981v-6.544h-3.152V97.139h3.152V92.39l7.223-.8v5.547h4.509v5.666h-4.509v6.544c0,1.277.678,1.915,2,1.915a4.48,4.48,0,0,0,2.115-.519Z",
    transform: "translate(-862.986 -68.455)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12884",
    "data-name": "Path 12884",
    d: "M1243.088,115.244q2.873,3.472,1.8,8.859h-13.847c.439,1.6,2.075,2.674,4.51,2.674a8.952,8.952,0,0,0,5.108-1.516l3.551,3.99a13.472,13.472,0,0,1-9.058,3.152q-5.327,0-8.38-2.753a9.483,9.483,0,0,1-3.073-7.462,9.951,9.951,0,0,1,2.993-7.5,10.9,10.9,0,0,1,7.861-2.873c3.751,0,6.584,1.157,8.539,3.432m-12.011,5.227h7.183c-.04-1.955-1.357-3.152-3.472-3.152-2.195,0-3.671,1.2-3.711,3.152",
    transform: "translate(-914.582 -83.568)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12885",
    "data-name": "Path 12885",
    d: "M84.1,108H23.9A23.9,23.9,0,0,1,0,84.1V23.9A23.9,23.9,0,0,1,23.9,0H84.1A23.9,23.9,0,0,1,108,23.9V84.1A23.9,23.9,0,0,1,84.1,108",
    fill: "#0076ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12886",
    "data-name": "Path 12886",
    d: "M154.621,97.757a33.79,33.79,0,0,0-2.952-7.458l-7.107,3.851A25.588,25.588,0,1,1,97.336,112.9a25.6,25.6,0,0,1,27.459-31.984l.863-8.037a33.67,33.67,0,0,0-29.4,55.1l-9.885,9.759,5.679,5.753,10.117-9.987a33.655,33.655,0,0,0,52.452-35.739",
    transform: "translate(-64.555 -54.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12887",
    "data-name": "Path 12887",
    d: "M638.166,275.869a3.8,3.8,0,0,1,4.11-3.791c2.434,0,4.15,1.556,4.15,3.791,0,2.195-1.716,3.751-4.15,3.751a3.794,3.794,0,0,1-4.11-3.751m.479,5.148h7.263v19.713h-7.263Z",
    transform: "translate(-476.961 -203.349)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12888",
    "data-name": "Path 12888",
    d: "M701.159,309.158q2.873,3.472,1.8,8.859H689.108c.439,1.6,2.075,2.674,4.509,2.674a8.951,8.951,0,0,0,5.108-1.516l3.551,3.99a13.472,13.472,0,0,1-9.058,3.152q-5.327,0-8.38-2.753a9.483,9.483,0,0,1-3.073-7.462,9.95,9.95,0,0,1,2.993-7.5,10.9,10.9,0,0,1,7.861-2.873c3.751,0,6.584,1.157,8.539,3.432m-12.011,5.227h7.183c-.04-1.955-1.357-3.152-3.472-3.152-2.195,0-3.671,1.2-3.711,3.152",
    transform: "translate(-509.548 -228.498)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12889",
    "data-name": "Path 12889",
    d: "M795.771,307.463h7.7l-6.624,19.713h-6.584l-1.476-4.349-2-5.587-1.955,5.587-1.517,4.349h-6.664l-6.584-19.713h7.661l1.517,5.387,1.2,5.427,4.15-10.814h4.39l4.15,10.814,1.2-5.427Z",
    transform: "translate(-575.548 -229.796)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12890",
    "data-name": "Path 12890",
    d: "M543.867,222.86,526.6,264.725h-7.943l-8.783-20.932h8.175l4.56,12.035,12.8-32.968Z",
    transform: "translate(-381.078 -166.564)",
    fill: "#071b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12891",
    "data-name": "Path 12891",
    d: "M207.852,93.092l-17.265,41.865h-7.943l-8.783-20.932h8.175l4.56,12.035,12.8-32.968Z",
    transform: "translate(-129.943 -69.577)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cce682e27bd6291a8f91e8b1b961c6ae.svg";
export { ForwardRef as ReactComponent };